<template>
  <v-dialog v-model="dialogValue" max-width="500px" lazy>
    <v-card>
      <v-alert :value="alertMessage" type="error">
        <ul v-if="Array.isArray(alertMessage)">
          <li v-for="(message, index) in alertMessage" :key="index">
            {{ message }}
          </li>
        </ul>
        <div v-else>
          {{ alertMessage }}
        </div>
      </v-alert>
      <v-form @submit.prevent="saveAddUser">
        <v-card-title>
          <span class="headline">
            Add New User
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap row justify-center>
              <v-flex xs11>
                <v-text-field v-model="addForm.firstName" v-validate="'required'" name="firstName" label="First Name*" required :error-messages="errors.collect('firstName')" />
              </v-flex>
              <v-flex xs11>
                <v-text-field v-model="addForm.lastName" v-validate="'required'" name="lastName" label="Last Name*" required :error-messages="errors.collect('lastName')" />
              </v-flex>
              <v-flex xs11>
                <v-text-field v-model="addForm.email" v-validate="'required|email'" name="email" label="Email*" required :error-messages="errors.collect('email')" />
              </v-flex>
              <v-flex xs11>
                <v-text-field v-model="addForm.newPassword" v-validate="'required'" type="password" name="newPassword" label="New Password*" required :error-messages="errors.collect('newPassword')" hint="User must change password on login" persistent-hint />
              </v-flex>
              <v-flex xs11>
                <v-text-field v-model="addForm.confirmPassword" v-validate="'required'" type="password" name="confirmPassword" label="Confirm Password*" required :error-messages="errors.collect('confirmPassword')" />
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <span class="pl-4">
            <small>*indicates required field</small>
          </span>
          <v-spacer />
          <v-btn flat @click="dialogValue = false">
            Close
          </v-btn>
          <v-btn type="submit" color="secondary darken-1" flat :loading="savingAddUser">
            Save Changes
          </v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      dialog: {
        type: Boolean,
        default: false,
      },
    },

    data: () => ({
      defaultAddForm: {
        firstName: '',
        lastName: '',
        email: '',
        newPassword: '',
        confirmPassword: '',
        userResetPassword: true,
      },
      addForm: {
        firstName: '',
        lastName: '',
        email: '',
        newPassword: '',
        confirmPassword: '',
        userResetPassword: true,
      },
      savingAddUser: false,
    }),

    computed: {
      dialogValue: {
        get() {
          return this.dialog;
        },
        set(value) {
          this.$emit('update:dialog', value);
        },
      },
    },

    watch: {
      dialogValue(val) {
        if (!val) {
          setTimeout(() => {
            Object.keys(this.addForm).filter(key => key in this.defaultAddForm).forEach(key => this.addForm[key] = this.defaultAddForm[key]); // eslint-disable-line
            this.clearErrors();
          }, 300);
        } else {
          this.$validator.pause();
        }
      },
    },

    methods: {
      async saveAddUser() {
        const result = await this.startFormProcessing();
        if (!result) return;
        this.saveAddUser = true;
        try {
          await axios.post('/api/system/user-management/users', this.addForm);
          this.$emit('getUsers');
          this.dialogValue = false;
        } catch (error) {
          this.processErrors(error, this.addForm);
        } finally {
          this.saveAddUser = false;
        }
      },
    },
  };
</script>
</template>